if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      this.isCustomProduct = !!(document.getElementById('active-color') || this.querySelector('#active-color'));
      this.hideErrors = this.dataset.hideErrors === 'true';

      // Thêm event listener để đảm bảo form values được update trước khi submit
      this.addEventListener('submit', this.ensureFormValuesUpdated.bind(this));
    }

    // MỚI: Đảm bảo tất cả form values được update trước khi submit
    ensureFormValuesUpdated() {
      // Trigger các custom option events để update hidden fields
      const customOptionElements = this.querySelectorAll('[data-custom-option]');
      customOptionElements.forEach(element => {
        if (typeof element.updateFormValues === 'function') {
          element.updateFormValues();
        }
      });

      // Dispatch custom event để JavaScript khác cập nhật form values
      const formUpdateEvent = new CustomEvent('formValuesUpdate', {
        bubbles: true,
        cancelable: true
      });
      this.form.dispatchEvent(formUpdateEvent);

      // Chờ 100ms để JavaScript khác hoàn thành cập nhật
      setTimeout(() => {
        console.log('Form values updated before submit');
      }, 100);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // **CẢI THIỆN: Lấy FormData và thêm tất cả custom properties**
      const formData = this.collectFormDataWithCustomProperties();
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
    
      //Added to generate selling plan add to cart response
      if (window.getCurrentSellingPlanId && typeof window.getCurrentSellingPlanId === 'function') {
        const sellingPlanId = window.getCurrentSellingPlanId();
        if (sellingPlanId) {
          formData.append("selling_plan", sellingPlanId);
        }
      }
      
      config.body = formData;

      const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      console.log('Submitting form data:', this.formDataToObject(formData));

      fetch(`${cartAddUrl}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // **MỚI: Thu thập tất cả form data bao gồm custom properties**
    collectFormDataWithCustomProperties() {
      // Tạo FormData từ form hiện tại
      const formData = new FormData(this.form);

      // **CẢI THIỆN: Thu thập tất cả input values trong form (kể cả hidden)**
      const allInputs = this.form.querySelectorAll('input, select, textarea');
      allInputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          if (input.checked) {
            formData.set(input.name, input.value);
          }
        } else if (input.value !== '' && input.name) {
          formData.set(input.name, input.value);
        }
      });

      // **MỚI: Thu thập properties từ các div với data attributes**
      const customProperties = this.collectCustomProperties();
      Object.keys(customProperties).forEach(key => {
        formData.set(`properties[${key}]`, customProperties[key]);
      });

      // **MỚI: Thu thập từ window object (nếu có)**
      if (window.currentCustomProperties) {
        Object.keys(window.currentCustomProperties).forEach(key => {
          formData.set(`properties[${key}]`, window.currentCustomProperties[key]);
        });
      }
      // remove not used properties
      formData.delete(`properties[User Quantity]`);
      formData.delete(`properties[Final Price]`);
      formData.delete(`properties[Collection]`);

      return formData;
    }

    // **MỚI: Thu thập custom properties từ các elements khác**
    collectCustomProperties() {
      const properties = {};
      
      // Tìm tất cả elements có data attributes là custom properties
      const customElements = document.querySelectorAll('[data-custom-property]');
      customElements.forEach(element => {
        const propertyName = element.dataset.customProperty;
        const propertyValue = this.getElementValue(element);
        if (propertyName && propertyValue) {
          properties[propertyName] = propertyValue;
        }
      });

      // Thu thập từ addon form (nếu có)
      const addonForm = document.getElementById('addon-form');
      if (addonForm) {
        // Thu thập từ radio buttons
        const selectedRadios = addonForm.querySelectorAll('input[type="radio"]:checked');
        selectedRadios.forEach(radio => {
          const inputName = radio.name;
          if (inputName && inputName.startsWith('properties[')) {
            const propertyName = inputName.match(/properties\[(.*?)\]/)?.[1];
            if (propertyName) {
              properties[propertyName] = radio.value;
            }
          }
        });

        // Thu thập từ text inputs
        const customInputs = addonForm.querySelectorAll('input[type="text"], input[type="number"]');
        customInputs.forEach(input => {
          const inputName = input.name;
          if (inputName && inputName.startsWith('properties[') && input.value.trim()) {
            const propertyName = inputName.match(/properties\[(.*?)\]/)?.[1];
            if (propertyName) {
              properties[propertyName] = input.value.trim();
            }
          }
        });

        // Thu thập từ hidden fields
        const hiddenInputs = addonForm.querySelectorAll('input[type="hidden"]');
        hiddenInputs.forEach(input => {
          const inputName = input.name;
          if (inputName && inputName.startsWith('properties[') && input.value) {
            const propertyName = inputName.match(/properties\[(.*?)\]/)?.[1];
            if (propertyName) {
              properties[propertyName] = input.value;
            }
          }
        });
      }

      // Thu thập từ size inputs
      const lengthInput = document.getElementById('size-length');
      const widthInput = document.getElementById('size-width');
      const quantityInput = document.getElementById('item-quantity');

      if (lengthInput && lengthInput.value) {
        properties['Length (inches)'] = lengthInput.value;
      }
      if (widthInput && widthInput.value) {
        properties['Width (inches)'] = widthInput.value;
      }
      if (quantityInput && quantityInput.value) {
        properties['User Quantity'] = quantityInput.value;
      }

      // Thu thập từ room label
      const roomLabelInput = document.getElementById('room-label');
      if (roomLabelInput && roomLabelInput.value.trim()) {
        properties['Room label'] = roomLabelInput.value.trim();
      }

      return properties;
    }

    // **MỚI: Lấy giá trị từ element dựa trên type**
    getElementValue(element) {
      if (element.tagName === 'INPUT') {
        if (element.type === 'checkbox' || element.type === 'radio') {
          return element.checked ? element.value : '';
        }
        return element.value;
      } else if (element.tagName === 'SELECT') {
        return element.value;
      } else if (element.tagName === 'TEXTAREA') {
        return element.value;
      }
      return element.textContent || '';
    }

    // **MỚI: Convert FormData thành object để debug**
    formDataToObject(formData) {
      const obj = {};
      for (let [key, value] of formData.entries()) {
        obj[key] = value;
      }
      return obj;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}